import { type FC, type PropsWithChildren } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';

import {
  SubFormDialog,
  type SubFormDialogProps,
} from '#packages/web/layouts/dialog/templates/sub-form';

export type SiteVisitDateFormDialogProps = Pick<
  SubFormDialogProps,
  'onClose' | 'open'
> & {
  control: Control<EditAuditFormBackgroundData>;
};

export const SiteVisitDateFormDialog: FC<
  PropsWithChildren<SiteVisitDateFormDialogProps>
> = ({
  open,

  control,

  onClose,
}) => (
  <SubFormDialog title="Site Visit Date" open={open} onClose={onClose}>
    <Grid container spacing={2}>
      <Controller
        control={control}
        name="general.siteVisitStartDate"
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Site visit start date and time"
              type="datetime-local"
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.siteVisitEndDate"
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Site visit end date and time"
              type="datetime-local"
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
    </Grid>
  </SubFormDialog>
);
